module.exports = __webpack_public_path__ + "static/media/2_1.5e7a45de.png";